<template>
	<div>
		<!-- <div style="display: flex;margin-bottom: 10px;opacity:0.5">
      <div style="display: flex;font-size: 12px;align-items: center;margin: 0px 7px;">
        <div style="height: 10px;width: 10px;border-radius: 50%;margin-right: 4px;background-color: #f86060;"></div>删除视频
      </div>

      <div style="display: flex;font-size: 12px;align-items: center;margin: 0px 7px;">
        <div style="height: 10px;width: 10px;border-radius: 50%;margin-right: 4px;background-color: #686868"></div>复制原链接
      </div>
      <div style="display: flex;font-size: 12px;align-items: center;margin: 0px 7px;">
        <div style="height: 10px;width: 10px;border-radius: 50%;margin-right: 4px;background-color: #47d222"></div>下载视频
      </div>
    </div> -->

		<el-alert title="视频仅保存3天，请尽快下载" type="info" effect="dark" show-icon style="margin-bottom: 10px;">
		</el-alert>
		<!-- <div style="display: flex;justify-content: flex-end;margin-bottom: 10px;">
			<el-button type="primary" icon="el-icon-refresh" circle size="small" plain></el-button>
		</div> -->
		<div style="display: flex;justify-content:space-between;margin-top: 10px;padding-bottom: 10px;">
		    <div style="width: auto;display: flex;">
		        <el-input size="small" placeholder="标题" clearable v-model="find_value" prefix-icon="el-icon-search"
		          @keyup.enter.native="jilu(); page = 1;cleartime=1" @clear="jilu(); page = 1"></el-input>
		        <el-button size="small" type="primary" style="margin-left: 5px;"
		          @click="jilu(); page = 1;cleartime=1">查找</el-button>
		    </div>
		    <!-- <el-button type="primary" size="small" @click="add_show = true; add_item = {}">+ 新建</el-button> -->
		</div>
		<div v-for="(item, i) in list" :key="i" style="margin-bottom: 10px;">
			<div v-if="item.zt1 == 3"
				style="display:flex;padding: 7px 5px;border: 1px solid #f1f1f1;border-radius: 10px;position: relative;">
				<div style="position:absolute;top: 0;bottom: 0;left: 0;right: 0;background-color: rgb(255 231 231 / 50%);z-index: 2;display: flex;justify-content: center;align-items: center;">
					<div>
						<div style="display: flex;align-items: center;">
							<!-- <i class="el-icon-warning" style="font-size: 20px;color: rgb(255 107 107);margin-right: 5px;"></i> -->
							<div style="font-size: 13px;">{{ item.url }}</div>
						</div>
						<div style="font-size: 12px;color:#999;text-align: center;">ID:{{ item.id }}</div>
					</div>
				</div>
				<div v-if="item.cover">
					<el-image style="width: 60px; height: 90px" :src="item.cover"></el-image>
				</div>
				<div style="margin-left: 10px;height: 90px;width: 100%;">
					<el-skeleton :rows="3" animated />
				</div>
				<div
					style="display: flex;position: absolute;bottom: 0;right: 0;margin-bottom: 5px;margin-right: 4px;z-index: 3;">
					<div style="display: flex;">
						<!-- <el-button class="tree_button i-botton" slot="suffix" type="text" icon="el-icon-delete"
							style="background-color: #f86060;color:#fff" @click="del_video(item.id)"></el-button> -->
						<el-button class="tree_button i-botton" slot="suffix" type="text" icon="el-icon-paperclip"
							style="background-color: #686868;color: #fff;" @click="_copy(item.yurl)"></el-button>
					</div>
				</div>
			</div>

			<div style="display:flex;padding: 7px 5px;border: 1px solid #f1f1f1;border-radius: 10px;position: relative;" v-else>
				<div>
					<el-image style="width: 60px; height: 100px;border-radius:5px;" :src="item.cover" fit="cover"></el-image>
				</div>
				<div style="margin-left: 10px;">
					<div v-if="item.title" style="display: flex;cursor: pointer;" @click.stop="_copy(item.title)">
						<div class="biaoti">{{ item.title }}</div>
						<div
							style="width: 50px;text-align: center;font-size: 12px;align-items: center;color: #888;background-color: #f3f3f3;border-radius: 3px;margin-left: 10px;min-width: 50px;">
							<i class="el-icon-document-copy"></i>
							复制
						</div>
					</div>
					<div v-else>无标题</div>
					<div style="margin-top: 5px;">
						<div v-if="item.spsj">
							<el-tag size="mini" style="font-size: 12px;">{{ item.spsj }}s</el-tag>
							<el-tag size="mini" style="font-size: 12px;" type="warning">费用{{ item.kcds }}点</el-tag>
							<el-tag size="mini" style="font-size: 12px;" type="info">ID{{ item.id }}</el-tag>
						</div>
					</div>
					<div style="font-size: 12px;color: #999;margin-top: 5px;">{{ item.time }}</div>
					<div
						style="display: flex;position: absolute;bottom: 0;right: 0;margin-bottom: 5px;margin-right: 4px;">

						<div style="display: flex;">
							<!-- <el-button class="tree_button i-botton" slot="suffix" type="text" icon="el-icon-delete"
								style="background-color: #f86060;color:#fff" @click="del_video(item.id)"></el-button> -->

							<!-- <el-button class="tree_button i-botton" slot="suffix" type="text" icon="el-icon-document-copy"
                style="background-color: #ffe66c;color: #000;" @click.stop="_copy(item.title)"></el-button> -->
							<el-button class="tree_button i-botton" slot="suffix" type="text" icon="el-icon-paperclip"
								style="background-color: #686868;color: #fff;" @click="_copy(item.url)"></el-button>
							<el-button class="tree_button i-botton" slot="suffix" type="text" icon="el-icon-download"
								style="background-color: #969696;color: #fff;" @click="downvideo(item, i)"
								v-if="item.is_down == 1"></el-button>
							<el-button class="tree_button i-botton" slot="suffix" type="text" icon="el-icon-download"
								style="background-color: rgb(71 210 34);color: #fff;" @click="downvideo(item, i)"
								v-else></el-button>
						</div>
					</div>
				</div>
			</div>

		</div>


		<div style="margin-top:10px;">
			<el-pagination background layout="total,prev, pager, next" :total="total" @current-change="fy_page"
				:current-page="page" small :page-size="10">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	var DSQ = null
	export default {
		name: '',
		components: {

		},
		filters: {
			formatDate(value) {
				let date = new Date(value * 1000);
				//时间戳为10位需*1000，时间戳为13位的话不需乘1000
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? ('0' + MM) : MM; //月补0
				let d = date.getDate();
				d = d < 10 ? ('0' + d) : d; //天补0
				let h = date.getHours();
				h = h < 10 ? ('0' + h) : h; //小时补0
				let m = date.getMinutes();
				m = m < 10 ? ('0' + m) : m; //分钟补0
				let s = date.getSeconds();
				s = s < 10 ? ('0' + s) : s; //秒补0
				//return y + '-' + MM + '-' + d; //年月日
				//return y + '-' + MM + '-' + d + ' ' + h + ':' + m+ ':' + s; //年月日时分秒
				return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s; //年月日时分秒

			},
		},
		// 定义属性
		data() {
			return {
				page: 1,
				total: 0,
				list: [],
				find_value:'',
			}
		},
		// 计算属性，会监听依赖属性值随之变化
		computed: {},
		// 监控data中的数据变化
		watch: {},
		// 方法集合
		methods: {
			del_video(e) {
				this.$confirm('此操作将永久删除记录, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					const loading = this.$loading(this.$loadinginfo);
					var data = {
						spid: e
					}
					// this.$ajax.post('/qhy/user/del_newsp', data, {
					// 	headers: {
					// 		'Content-Type': 'application/x-www-form-urlencoded'
					// 	}
					// }).then(res => {
					// 	// console.log(res.data)
					// 	if (res.data.status == 200) {
					// 		this.jilu()
					// 		this.$message.success(res.data.msg)

					// 	} else {
					// 		this.$message.error(res.data.msg)
					// 	}
					// 	loading.close();
					// })
				})
			},
			fy_page(e) {
				console.log(e)
				this.page = e
				this.jilu()
			},
			downvideo(e, i) {
				if(e.url){
					// fetch(e.url).then(res => res.blob()).then(blob => {
					//  const a = document.createElement('a');
					//   document.body.appendChild(a)
					//   a.style.display = 'none'
					//   const url = window.URL.createObjectURL(blob);
					//   a.href = url;
					//   a.download = '视频.mp4';
					//   a.click();
					//   document.body.removeChild(a)
					//   window.URL.revokeObjectURL(url);
					// })
					this.downvideo_ok(e.unid);
					this.list[i].is_down = 1
					window.open(e.url, "_blank");
				}else{
					this.$message('暂无链接')
				}
			},
			downvideo_ok(id) {
				var httpData = {
					unid: id
				}
				this.$http.post("/api/video/download",httpData,{load:false}).then(res => {})
			},
			_copy(context) {
				// 创建输入框元素
				try {
					let oInput = document.createElement('textarea');
					// 将想要复制的值

					oInput.value = context.replaceAll("qhy7672", "\n");;
					// 页面底部追加输入框
					document.body.appendChild(oInput);
					// 选中输入框
					oInput.select();
					// 执行浏览器复制命令
					document.execCommand('Copy');
					// 弹出复制成功信息
					this.$message.success('复制成功');
					// 复制后移除输入框
					oInput.remove();
				} catch (e) {
					this.$message.error('复制失败,此任务没有原链接');
				}
			},
			jilu() {
				var httpData={
					p:this.page,
					keyword:this.find_value,
				}
				this.$http.post("/api/video/getRecord",httpData,{load:false}).then(res => {
					this.list = res.list
					this.total = res.count
					console.log(this.list,'this.list')
				})
			},
		},
		// 生命周期 - 创建完成（可以访问当前this实例）
		created() {},
		// 生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {
			this.jilu()
			DSQ && clearInterval(DSQ)
			DSQ = setInterval(()=>{
				this.jilu()
			},30000)
		},
		beforeCreate() {}, // 生命周期 - 创建之前
		beforeMount() {}, // 生命周期 - 挂载之前
		beforeUpdate() {}, // 生命周期 - 更新之前
		updated() {}, // 生命周期 - 更新之后
		beforeDestroy() {
			DSQ && clearInterval(DSQ)
		}, // 生命周期 - 销毁之前
		destroyed() {}, // 生命周期 - 销毁完成
		activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
	}
</script>

<style scoped>
	.biaoti {
		font-size: 13px;
		overflow: hidden;
		word-break: break-all;
		/* break-all(允许在单词内换行。) */
		text-overflow: ellipsis;
		/* 超出部分省略号 */
		display: -webkit-box;
		/** 对象作为伸缩盒子模型显示 **/
		-webkit-box-orient: vertical;
		/** 设置或检索伸缩盒对象的子元素的排列方式 **/
		-webkit-line-clamp: 1;
		/** 显示的行数 **/
		/* lines: 1; */
	}
	.i-botton {
		width: 30px;
		height: 30px;
		border-radius: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		/* font-size: 12px; */
		margin: 0px 3px;
	}
</style>